import ArticleProduct from './ArticleProduct'

export default ArticleProduct